import { AfterContentInit, ChangeDetectorRef, Component, Input, inject } from "@angular/core";
import { Zeiterfassung } from "../../../../formular-model/formular-groups/interfaces/FormularGroupZeiterfassung";

import { CstListViewDataSource, ICstGuiCommand, ICstListViewColumn } from "src/app/common-components/list-view/models";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import { NewOrEditZeiterfassungPopupComponent } from "../popup/popup";
import { of } from "rxjs";
import { tap } from "rxjs/operators";
import { getDate, getTime, ItemRequest, ItemResult } from "../zeiterfassung.types";

@Component({
    selector: 'tab-formular-zeiterfassung-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class FormularGroupZeiterfassungTableComponent implements AfterContentInit {
    private _popup = inject(CstResponsivePopupService);
    private _cdr = inject(ChangeDetectorRef);

    @Input() data: Zeiterfassung[];
    public dataSource: CstListViewDataSource<Zeiterfassung> = null;
    public columns: ICstListViewColumn<Zeiterfassung>[] = null;
    public actions: ICstGuiCommand<Zeiterfassung>[] = null;

    private _cmdEditRow: ICstGuiCommand<Zeiterfassung> = {
        icon: "edit",
        label: "Edit",
        tooltip: "Edit this row",
        execute: (item) => this._editRow(item),
        canExecute: (item) => this._canEditRow(item),
    };

    private _editRow(item: Zeiterfassung): void {
        const index = this.data.findIndex(e => e === item);
        this.onEditItem(index);
    }

    private _canEditRow(_item: Zeiterfassung): boolean {
        return true;
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private _cmdRemoveRow: ICstGuiCommand<Zeiterfassung> = {
        icon: "delete",
        label: "Remove",
        tooltip: "Remove this row",
        execute: (item) => this._removeRow(item),
        canExecute: (item) => this._canRemoveItem(item),
    };

    private _canRemoveItem(_item: Zeiterfassung) {
        return true;
    }

    private _removeRow(_item: Zeiterfassung): void {
        this.data = this.data.filter(item => item !== _item);
        this.refresh();
    }

    constructor() {
        this.dataSource = new CstListViewDataSource<Zeiterfassung>({
            sorting: {
                column: "Name",
                direction: "asc",
                enableServerSideSorting: false,
            }
        });

        this.columns = [
            {
                header: "Name",
                field: "Name",
            },
            {
                header: "Datum",
                field: "ArbeitszeitBeginn",
                converter: (value) => getDate(value)
            },
            {
                header: "Arbeitszeit",
                field: "Arbeitszeit",
                converter: (value) => getTime(value)
            },
            {
                header: "Fahrtzeit",
                field: "Fahrtzeit",
                converter: (value) => getTime(value)
            },
            {
                header: "Gesamtzeit",
                field: "Gesamtzeit",
                converter: (value) => getTime(value)
            },
            {
                header: "Zone",
                field: "Zone",
            }
        ];

        this.actions = [this._cmdEditRow, this._cmdRemoveRow];
    }

    ngAfterContentInit(): void {
        this.dataSource.registerFetchDataCallback(
            () => of({ data: this.data, total: this.data.length })
        )

        this.refresh();
    }

    onEditItem(index: number) {
        const dialogRef = this._popup.open<NewOrEditZeiterfassungPopupComponent, ItemRequest, ItemResult | null>(
            NewOrEditZeiterfassungPopupComponent,
            {
                data:
                {
                    state: "edit",
                    data: this.data[index],
                }
            }
        );

        return dialogRef
            .afterClosed()
            .pipe(
                tap((result: ItemResult | null) => this._handleEditItem(index, result))
            )
            .subscribe({
                error: (error) => console.error(error)
            })
    }

    private _handleEditItem(index: number, itemResult: ItemResult) {
        if (!itemResult || !itemResult.state || !itemResult.data) return;

        this.data[index] = itemResult.data;
        this.refresh();
    }

    public refresh() {
        this.dataSource.refresh();
        this._cdr.detectChanges();
    }
}
